import { GeometryApi, InventoryBoundary, mergeFeatureCollection } from '@cibo/core'
import { featureCollection } from '@turf/turf'
import { Feature, Geometry } from 'geojson'
import { groupBy, pick, pluck, prop } from 'ramda'

export const getBoundaryFeature = async (boundary: InventoryBoundary) => {
  const areaDefsByType = groupBy(prop('type'), boundary.areaDef)

  const fips = []
  for (const area of areaDefsByType?.['fips'] || []) {
    if (area?.fips) fips.push(area.fips)
  }

  const fipsGeometries = fips.length
    ? await GeometryApi.getGeometries(fips).then(({ features }) => features)
    : []

  const featureAreaFeatures = pluck('feature', areaDefsByType['feature'] || [])
  const fc = featureCollection<Geometry>([
    ...(fipsGeometries as Feature[]),
    ...(featureAreaFeatures as Feature[]),
  ])

  // @ts-ignore never a GeometryCollection afaik
  const feature = mergeFeatureCollection(fc) as Feature<Geometry>

  if (!feature) return

  feature.id = boundary.boundaryId
  feature.properties = pick(
    [
      'acreage',
      'boundaryId',
      'createdDate',
      'crops',
      'enabled',
      'inventoryId',
      'modifiedDate',
      'name',
      'type',
    ],
    boundary
  )

  return feature
}
